module.exports = __webpack_public_path__ + "static/img/topbar-3.70581bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/topbar-3.png
// module id = iccS
// module chunks = 0